import React, { useEffect, useMemo, useState } from "react";
import carregando from "../../assets/loading.gif";
import api from "../../services/api";
import Header from "../../Header";
import SideMenu from "../../SideMenu";
import Footer from "../../Footer";
import DataTable from "react-data-table-component";

function formatStatus(status) {
  if (status === 1) return "Confirmado";
  if (status === 2) return "Cancelado";
  return "Pendente";
}

function formatDate(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleString("pt-BR");
}

function formatMoney(value) {
  if (value === undefined || value === null || value === "") return "-";
  const n = Number(value);
  if (Number.isNaN(n)) return "-";
  return n.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export default function List_Pedidos({ history }) {
  const [pedidos, setPedidos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busca, setBusca] = useState("");

  const empresaid = localStorage.getItem("sgiempresaid");
  const isMaster = localStorage.getItem("sgimaster");

  async function loadPedidos() {
    const response = await api.get("/treinamentos/pedido", {
      headers: { "x-tenantid": empresaid, isMaster },
    });
    const data = await response.data;

    const term = (busca || "").trim().toLowerCase();
    const filtered = !term
      ? data
      : data.filter((p) => {
          const hay = `${p?._id ?? ""} ${p?.useremail ?? ""} ${p?.nome ?? ""} ${p?.telefone ?? ""}`.toLowerCase();
          return hay.includes(term);
        });

    setPedidos(filtered);
    setLoading(false);
  }

  function efetivaBusca() {
    setLoading(true);
    loadPedidos();
  }

  const goToPage = (row) => {
    history.push("/pedido/" + row._id);
  };

  const columns = useMemo(
    () => [
      { name: "Status", selector: (row) => formatStatus(row.status), sortable: true, width: "130px" },
      { name: "Total (R$)", selector: (row) => formatMoney(row.total), sortable: true, width: "130px" },
      { name: "E-mail", selector: (row) => row.useremail, wrap: true, sortable: true },
      { name: "Nome", selector: (row) => row.nome, wrap: true, sortable: true },
      { name: "Telefone", selector: (row) => row.telefone, wrap: true, sortable: true, width: "160px" },
      { name: "Criado em", selector: (row) => formatDate(row.createdAt), sortable: true, width: "170px" },
    ],
    []
  );

  useEffect(() => {
    setLoading(true);
    loadPedidos();

    setTimeout(() => {
      if (document.getElementById("menu_pedido")) {
        document.getElementById("menu_pedido").className = "active";
      }
    }, 50);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Header />
      <SideMenu />

      <div>
        <div className="content-wrapper">
          <section className="content-header">
            <h1>
              Pedidos<small> - Somente visualização</small>
            </h1>
          </section>

          <section className="content">
            <div className="row">
              <div className="col-xs-12">
                <div className="box">
                  {loading && (
                    <div style={{ alignItems: "center", textAlign: "center" }}>
                      <img src={carregando} width="80" alt="" />
                    </div>
                  )}

                  <div className="box-body table-responsive">
                    <div className="col-md-12 nopadding" style={{ marginBottom: "20px" }}>
                      <div className="col-md-6 nopadding" />
                      <div className="col-md-6 text-right" style={{ paddingTop: 10 }}>
                        <div style={{ display: "inline-flex", gap: "10px" }}>
                          <input
                            className="form-control"
                            style={{ width: "250px", display: "inline-block" }}
                            placeholder="Buscar (id, e-mail, nome, telefone)..."
                            value={busca}
                            onChange={(event) => setBusca(event.target.value)}
                          />
                          <button className="btn btn-primary" onClick={efetivaBusca}>
                            <i className="fa fa-search" style={{ marginRight: "5px" }} />
                            Buscar
                          </button>
                        </div>
                      </div>
                    </div>

                    <DataTable
                      columns={columns}
                      data={pedidos}
                      onRowClicked={goToPage}
                      pointerOnHover
                      highlightOnHover
                      noDataComponent={""}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </>
  );
}
